<template>
  <div>
    <div
      class="modal fade"
      id="modalBarraPosicion"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Escanee la barra posición</h6>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="class col-12">
              <label>Barra Posición</label>
              <input
                type="text"
                class="form-control"
                ref="barra_posicionx"
                v-model="current.barra_posicion"
              />
            </div>
            <div class="class col-12">
              <TiendaSelectComponent :current="current" />
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="verInventarioDeEstacion()"
              class="btn btn-success btn-block btn-md"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalExistencias"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Inventario en posición</h6>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <div style="height: 400px; overflow: auto" class="modal-body">
            <table class="table table-compact smaller text-faded mb-0">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Lote</th>
                  <th>Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="existencia in existencias" :key="existencia.id">
                  <td class="text-bright">
                    {{ existencia.sku }} - {{ existencia.nombre_sku }}
                  </td>
                  <td class="text-right">
                    {{ existencia.codigo_lote }}
                  </td>
                  <td
                    v-bind:class="{
                      'text-danger': existencia.cantidad < 0,
                    }"
                    class="text-right text-success"
                  >
                    {{ existencia.cantidad }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: { TiendaSelectComponent },
  props: {
    existencias: {
      type: Array,
    },
    seleccionada: {
      type: Object,
    },
  },
  data() {
    return {
      current: { barra_posicion: "", tienda: {} },
    };
  },
  mounted() {
    let self = this;
  },
  methods: {
    verInventarioDeEstacion() {
      let self = this;
      DynamicService.getActionList(
        "wms",
        "picking-despacho",
        "inventario_posicion",
        self.current
      )
        .then((response) => {
          self.existencias = response.data;
          $("#modalExistencias").modal("show");
          $("#modalBarraPosicion").modal("hide");
          self.current.tienda = {};
          self.current.barra_posicion = "";
        })
        .catch((errors) => {
          self.current.tienda = {};
          self.current.barra_posicion = "";
          Notifications.alert.error(
            "Inventario de estación",
            errors.response.data.detail
          );
        });
    },
  },
};
</script>
